export enum JobStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Queued = 'Queued',
  Active = 'Active'
}

export type Job = {
  _id: string
  status: JobStatus
  result?: {
    data: Array<string>
  }
}
